import { render, staticRenderFns } from "./产权需求详情_阶梯竞价版本.vue?vue&type=template&id=0c565fd6&scoped=true"
import script from "./产权需求详情_阶梯竞价版本.vue?vue&type=script&lang=js"
export * from "./产权需求详情_阶梯竞价版本.vue?vue&type=script&lang=js"
import style0 from "./产权需求详情_阶梯竞价版本.vue?vue&type=style&index=0&id=0c565fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c565fd6",
  null
  
)

export default component.exports